import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'

import Home from '@/views/Home'
import Login from '@/views/Login'
import Admins from '@/views/Users'

import Peca from '@/views/pages/Peca'
import PecaPecas from '@/views/pages/peca/Pecas'
import PecaMarcas from '@/views/pages/peca/Marcas'
import PecaTipos from '@/views/pages/peca/Tipos'
import PecaPecasMarcaTipo from '@/views/pages/peca/PecasMarcaTipo'

import Maquina from '@/views/pages/Maquina'
import MaquinaMaquinas from '@/views/pages/maquina/Maquinas'
import MaquinaMarcas from '@/views/pages/maquina/Marcas'
import MaquinaModelos from '@/views/pages/maquina/Modelos'
import MaquinaMaquinasMarcaModelo from '@/views/pages/maquina/MaquinasMarcaModelo'

import Distribuidoras from '@/views/pages/Distribuidoras'

import Error404 from '@/views/Error404'

Vue.use(VueRouter)

function lazyLoadPessoas(view){
  return() => import(`@/views/pages/pessoas/${view}`)
}
function lazyLoadEmpresas(view){
  return() => import(`@/views/pages/empresas/${view}`)
}
function lazyLoadCursos(view){
  return() => import(`@/views/pages/cursos/${view}`)
}
function lazyLoadCadastro(view){
  return() => import(`@/views/pages/cadastro/${view}`)
}
function lazyLoadRelatorios(view){
  return() => import(`@/views/pages/relatorios/${view}`)
}

const router = new VueRouter({
	routes: [
		{
			// path: '/:id(\\d+)',
			path: '/Home',
			component: Home,
			name: 'Home',
			meta: { 
				title: 'Home',
				breadCrumb: 'Home',
				requiresAuthentication: true
			}
		},
		{
			path: '/Cadastro',
			component: lazyLoadCadastro('Cadastro'),
			name: 'Cadastro',
			meta: { 
				title: 'Cadastro',
				breadCrumb: 'Cadastro',
				requiresAuthentication: false
			},
			children: [
				{
					path: 'User',
					component: lazyLoadCadastro('CadastroUser'),
					name: 'CadastroUser',
					meta: { 
						title: 'Cadastro User',
						breadCrumb: 'Cadastro User',
						requiresAuthentication: false
					}
				},
				{
					path: 'Empresa',
					component: lazyLoadCadastro('CadastroEmpresa'),
					name: 'CadastroEmpresa',
					meta: { 
						title: 'Cadastro Empresa',
						breadCrumb: 'Cadastro Empresa',
						requiresAuthentication: false
					}
				},
			]
		},
		{
			path: '/Admins',
			component: Admins,
			name: 'Admins',
			meta: { 
				title: 'Admins',
				breadCrumb: 'Admins',
				requiresAuthentication: true
			},
		},
		{
			path: '/Pessoas',
			component: lazyLoadPessoas('Pessoas'),
			name: 'Pessoas',
			meta: { 
				title: 'Pessoas',
				breadCrumb: 'Pessoas',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'List',
					component: lazyLoadPessoas('PessoasList'),
					name: 'PessoasList',
					meta: { 
						title: 'Pessoas',
						breadCrumb: 'Pessoas',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)/Contatos',
					component: lazyLoadPessoas('PessoaContatos'),
					name: 'PessoaContatos',
					meta: { 
						title: 'Contatos',
						breadCrumb: 'Contatos',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)/Cursos',
					component: lazyLoadPessoas('PessoaCursos'),
					name: 'PessoaCursos',
					meta: { 
						title: 'Cursos',
						breadCrumb: 'Cursos',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)/Empresas',
					component: lazyLoadPessoas('PessoaEmpresas'),
					name: 'PessoaEmpresas',
					meta: { 
						title: 'Empresas',
						breadCrumb: 'Empresas',
						requiresAuthentication: true
					}
				},
			]
		},
		{
			path: '/Empresas',
			component: lazyLoadEmpresas('Empresas'),
			name: 'Empresas',
			meta: { 
				title: 'Empresas',
				breadCrumb: 'Empresas',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'List',
					component: lazyLoadEmpresas('EmpresasList'),
					name: 'EmpresasList',
					meta: { 
						title: 'Empresas',
						breadCrumb: 'Empresas',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)/Contatos',
					component: lazyLoadEmpresas('EmpresaContatos'),
					name: 'EmpresaContatos',
					meta: { 
						title: 'Contatos',
						breadCrumb: 'Contatos',
						requiresAuthentication: true
					}
				},
				{
					path: 'Cargos',
					component: lazyLoadEmpresas('CargosList'),
					name: 'CargosList',
					meta: { 
						title: 'Cargos',
						breadCrumb: 'Cargos',
						requiresAuthentication: true
					}
				},
			]
		},
		{
			path: '/Cursos',
			component: lazyLoadCursos('Cursos'),
			name: 'Cursos',
			meta: { 
				title: 'Cursos',
				breadCrumb: 'Cursos',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'List',
					component: lazyLoadCursos('CursosList'),
					name: 'CursosList',
					meta: { 
						title: 'Cursos',
						breadCrumb: 'Cursos',
						requiresAuthentication: true
					}
				},
				{
					path: ':id(\\d+)/Periodos',
					component: lazyLoadCursos('CursoPeriodos'),
					name: 'CursoPeriodos',
					meta: { 
						title: 'Periodos',
						breadCrumb: 'Periodos',
						requiresAuthentication: true
					}
				},
			]
		},
		{
			path: '/Relatorios',
			component: lazyLoadRelatorios('Relatorios'),
			name: 'Relatorios',
			meta: { 
				title: 'Relatorios',
				breadCrumb: 'Relatorios',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'PessoasByEmpresa',
					component: lazyLoadRelatorios('PessoasByEmpresa'),
					name: 'PessoasByEmpresa',
					meta: { 
						title: 'PessoasByEmpresa',
						breadCrumb: 'PessoasByEmpresa',
						requiresAuthentication: true
					}
				},
				{
					path: 'EmailByPessoas',
					component: lazyLoadRelatorios('EmailByPessoas'),
					name: 'EmailByPessoas',
					meta: { 
						title: 'EmailByPessoas',
						breadCrumb: 'EmailByPessoas',
						requiresAuthentication: true
					}
				},
				{
					path: 'SujestaoEmpresas',
					component: lazyLoadRelatorios('SujestaoEmpresas'),
					name: 'SujestaoEmpresas',
					meta: { 
						title: 'SujestaoEmpresas',
						breadCrumb: 'SujestaoEmpresas',
						requiresAuthentication: true
					}
				},
			]
		},
				
		{
			path: '/Peca',
			component: Peca,
			name: 'Peca',
			meta: { 
				title: 'Peça',
				breadCrumb: 'Peça',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'Pecas',
					component: PecaPecas,
					name: 'PecaPecas',
					meta: { 
						title: 'Peças',
						breadCrumb: 'Peças',
						requiresAuthentication: true
					}
				},
				{
					path: 'Marcas',
					component: PecaMarcas,
					name: 'PecaMarcas',
					meta: { 
						title: 'Marcas',
						breadCrumb: 'Marcas',
						requiresAuthentication: true
					}
				},
				{
					path: 'Tipos',
					component: PecaTipos,
					name: 'PecaTipos',
					meta: { 
						title: 'Tipos',
						breadCrumb: 'Tipos',
						requiresAuthentication: true
					}
				},
				{
					path: 'PecaPecasMarcaTipo',
					component: PecaPecasMarcaTipo,
					name: 'PecaPecasMarcaTipo',
					meta: { 
						title: 'Peças com marca e tipo',
						breadCrumb: 'Peças com marca e tipo',
						requiresAuthentication: true
					}
				}
			]
		},
		{
			path: '/Maquina',
			component: Maquina,
			name: 'Maquina',
			meta: { 
				title: 'Máquina',
				breadCrumb: 'Máquina',
				requiresAuthentication: true,
				bloqueiaNavegacao: true
			},
			children: [
				{
					path: 'Maquinas',
					component: MaquinaMaquinas,
					name: 'MaquinaMaquinas',
					meta: { 
						title: 'Máquinas',
						breadCrumb: 'Máquinas',
						requiresAuthentication: true
					}
				},
				{
					path: 'Marcas',
					component: MaquinaMarcas,
					name: 'MaquinaMarcas',
					meta: { 
						title: 'Marcas',
						breadCrumb: 'Marcas',
						requiresAuthentication: true
					}
				},
				{
					path: 'Modelos',
					component: MaquinaModelos,
					name: 'MaquinaModelos',
					meta: { 
						title: 'Modelos',
						breadCrumb: 'Modelos',
						requiresAuthentication: true
					}
				},
				{
					path: 'MaquinaMaquinasMarcaModelo',
					component: MaquinaMaquinasMarcaModelo,
					name: 'MaquinaMaquinasMarcaModelo',
					meta: { 
						title: 'Máquinas com marca e modelo',
						breadCrumb: 'Máquinas com marca e modelo',
						requiresAuthentication: true
					}
				}
			]
		},
		{
			path: '/Distribuidoras',
			component: Distribuidoras,
			name: 'Distribuidoras',
			meta: { 
				title: 'Distribuidoras',
				breadCrumb: 'Distribuidoras',
				requiresAuthentication: true
			}
		},
		{
			path: '/login',
			component: Login,
			name: 'Login',
			meta: { 
				title: 'Login - CETABA',
				isAuthenticated: true 
			}
		},
		{ 
			path: '/', 
			redirect: { name: 'Home' }
		},
		{
			path: '*',
			component: Error404,
			meta: { 
				title: 'Página não encontrada'
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	const authenticated = store.state.authenticated
	if (to.matched.some(rota => rota.meta.requiresAuthentication)) {
		if (!authenticated) {
			next({
				name: 'Login',
				query: { redirect: to.fullPath }
			})
			return
		}
	}
	if (to.matched.some(rota => rota.meta.isAuthenticated)) {
		if (authenticated) {
			next({
				name: 'Home'
			})
			return
		}
	}
	if (to.matched.some(rota => rota.meta.bloqueiaNavegacao)) {
		if (to.meta.bloqueiaNavegacao === true) {
			next(false)
			return
		}
	}
	next()
})

router.afterEach((to) => {
	Vue.nextTick(() => {
			document.title = to.meta.title || 'Gerenciador';
	});
});


export default router
